// SPEC-206 — formatos de fechas, montos y porcentajes del historial de versiones, en es-CO y en
// la hora de Bogotá (la del negocio), sin depender de la zona del navegador.
const ZONA = 'America/Bogota';

// "13 de oct. de 2026" → "13 oct 2026": sin el punto del mes ni el " de " intermedio (design §7b).
function sinPuntoEnMes(partes: Intl.DateTimeFormatPart[]): string {
  return partes
    .map((p) => {
      if (p.type === 'month') return p.value.replace('.', '');
      if (p.type === 'literal' && p.value.trim() === 'de') return ' ';
      return p.value;
    })
    .join('');
}

// "13 oct 2026, 3:42 p. m."
export function formatFechaHora(iso: string): string {
  const formato = new Intl.DateTimeFormat('es-CO', {
    day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: ZONA,
  });
  return sinPuntoEnMes(formato.formatToParts(new Date(iso)));
}

// "5 oct" — fecha de envío de una versión.
export function formatDiaMes(iso: string): string {
  const formato = new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', timeZone: ZONA });
  return sinPuntoEnMes(formato.formatToParts(new Date(iso)));
}

// "13 oct, 3:40 p. m." — último intento de envío.
export function formatDiaMesHora(iso: string): string {
  const formato = new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', timeZone: ZONA });
  return sinPuntoEnMes(formato.formatToParts(new Date(iso)));
}

// "05/10/2026"
export function formatFechaCorta(iso: string): string {
  return new Intl.DateTimeFormat('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: ZONA }).format(new Date(iso));
}

// "28 oct" desde una fecha sin hora ("YYYY-MM-DD"), sin corrimiento de día.
export function formatFechaSinHora(fecha: string): string {
  const [anio, mes, dia] = fecha.split('-').map(Number);
  const formato = new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short', timeZone: 'UTC' });
  return sinPuntoEnMes(formato.formatToParts(new Date(Date.UTC(anio, mes - 1, dia))));
}

// "+7,9 %" / "−3,1 %"
export function formatVariacion(pct: number): string {
  const signo = pct < 0 ? '−' : '+';
  return `${signo}${Math.abs(pct).toLocaleString('es-CO', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %`;
}

// "+$ 310.000" / "−$ 120.000"
export function formatDiferencia(valor: number): string {
  const signo = valor < 0 ? '−' : '+';
  return `${signo}$ ${Math.abs(Math.round(valor)).toLocaleString('es-CO', { maximumFractionDigits: 0 })}`;
}

// SPEC-206 (RN-008) — hoy en Bogotá + 15 días, "YYYY-MM-DD" (validez propuesta al reenviar).
export function hoyMas15Bogota(ahora: Date = new Date()): string {
  const [anio, mes, dia] = new Intl.DateTimeFormat('en-CA', { timeZone: ZONA, year: 'numeric', month: '2-digit', day: '2-digit' })
    .format(ahora)
    .split('-')
    .map(Number);
  return new Date(Date.UTC(anio, mes - 1, dia + 15)).toISOString().slice(0, 10);
}
